/**
 * Shared defaults for newly created joints.
 * Keeps all "add joint" entry points consistent.
 */
export function createDefaultJointInput(kind = "hinge", name = null) {
  const safeKind =
    kind === "hinge" || kind === "slide" || kind === "ball" || kind === "free" ? kind : "hinge";

  const jointName = typeof name === "string" && name.trim() ? name.trim() : `joint_${safeKind}`;

  const basic = {
    name: jointName,
    kind: safeKind,
    group: 0,
    stiffness: 0,
    damping: 0,
    frictionloss: 0,
    springDamper: [0, 0],
    armature: 0,
    frictionSolverReference: [0.02, 1],
    frictionSolverImpedance: [0.9, 0.95, 0.001, 0.5, 2],
  };

  if (safeKind === "free") {
    return basic;
  }

  const limits = {
    useLimits: safeKind === "slide" ? "false" : "auto",
    contactMargin: 0.01,
    limitSolverReference: [0.02, 1],
    limitSolverImpedance: [0.9, 0.95, 0.001, 0.5, 2],
  };

  if (safeKind === "ball") {
    return {
      ...basic,
      ...limits,
      position: [0, 0, 0],
      max_rotation: Math.PI,
    };
  }

  const scalarRange = safeKind === "slide" ? [0, 1] : [-Math.PI, Math.PI];

  return {
    ...basic,
    ...limits,
    actfrclimited: 0,
    actfrcrange: [-Infinity, Infinity],
    actgravcomp: 0,
    position: [0, 0, 0],
    axis: [0, 0, 1],
    ref: 0,
    restingPosition: 0,
    range: scalarRange,
  };
}
